// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
import keyMirror from 'mattermost-redux/utils/key_mirror';

export default keyMirror({
    RECEIVED_SCHEME: null,

    RECEIVED_SCHEMES: null,

    CREATED_SCHEME: null,

    DELETED_SCHEME: null,

    PATCHED_SCHEME: null,

    RECEIVED_SCHEME_TEAMS: null,

    RECEIVED_SCHEME_CHANNELS: null,
});
